import React from "react";
import PropTypes from "prop-types";
import BurgerMenuItem from "../burger-menu-item/burger-menu-item";
import BurgerMenuSecondaryHeader from "../burger-menu-secondary-header/burger-menu-secondary-header";


function BurgerMenuCategoryMenu({ genderedMenu, selectedCategory, onBackToMainClick }) {
    var categoryMenu = genderedMenu.by_category.categories.filter((category) => {
        return category.name === selectedCategory;
    })[0];
    return (
        <div>
            <BurgerMenuSecondaryHeader
                renderText={selectedCategory}
                onClickEvent={onBackToMainClick}
            />
            <ul>
                {categoryMenu.links.map((link) => {
                    return <BurgerMenuItem key={link.url} renderText={link.text} href={link.url} />;
                })}
            </ul>
        </div>
    );
}

export default BurgerMenuCategoryMenu;

BurgerMenuCategoryMenu.propTypes = {
    genderedMenu: PropTypes.object,
    selectedCategory: PropTypes.string,
    onBackToMainClick: PropTypes.func.isRequired,
};

BurgerMenuCategoryMenu.defaultProps = {
    genderedMenu: {},
    selectedCategory: "",
};
